import { render, staticRenderFns } from "./ProductLabelCreateForm.vue?vue&type=template&id=4259761e&scoped=true&"
import script from "./ProductLabelCreateForm.vue?vue&type=script&lang=js&"
export * from "./ProductLabelCreateForm.vue?vue&type=script&lang=js&"
import style0 from "./ProductLabelCreateForm.vue?vue&type=style&index=0&id=4259761e&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4259761e",
  null
  
)

export default component.exports